var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "location-control-bislet text-body06-regular" },
    [
      _c(
        "b-form-group",
        {
          staticClass: "no-gap-form-group",
          attrs: {
            label: _vm.$t("message.pickUpLocation"),
            "lable-for": "location-selection",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "location-control",
              attrs: { id: "location-selection" },
            },
            [
              _c("b-form-select", {
                staticClass: "location-control-input text-body06-regular",
                attrs: {
                  options: _vm.locations,
                  "value-field": "id",
                  "text-field": "name",
                },
                model: {
                  value: _vm.internalValue,
                  callback: function ($$v) {
                    _vm.internalValue = $$v
                  },
                  expression: "internalValue",
                },
              }),
              _c(
                "button",
                {
                  staticClass: "location-control-icondiv",
                  on: {
                    click: function ($event) {
                      return _vm.getMyLocation()
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "location-control-icon",
                    attrs: {
                      src: require("@/assets/icon/v3/search.svg"),
                      alt: "search",
                    },
                  }),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }